import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Page, Pane, PaneBackButton, PaneHeader } from '../../components/atoms/applications/page';
import './attendancePage.module.scss';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { groupByDate } from '../../../commonv3/types/reservable';
import { AttendancePageState } from './states/AttendancePageState';
import { ReservationCard } from '../../components/molecules/reservations/ReservationCard';
import { ReservationCardList } from '../../components/molecules/reservations/ReservationCardList';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { authenticated } from '../../components/hocs/authenticated';

@authenticated
@observer
export class AttendancePage extends React.Component {
    pageState = new AttendancePageState();

    async componentDidMount() {
        await this.pageState.init();
    }
    render() {
        const { loading, allReservationList } = this.pageState;
        const currentUser = GlobalStatesV3.currentUser;
        return (
            <Page>
                {loading && <LoaderRow />}
                <div styleName="header">
                    {GlobalStatesV3.currentUser.isSignedIn() ? (
                        <div styleName="text">
                            <span styleName="name">{currentUser.currentUser.name}</span> さんこんにちは！
                        </div>
                    ) : (
                        <div />
                    )}
                    <div styleName="text">予約内容を確認し出席ボタンをタップしてください</div>
                </div>
                <div styleName="body">
                    <div styleName="reservation_count">
                        本日の予約数<span styleName="no">{allReservationList.length}</span>件
                    </div>
                    {allReservationList.length > 0 ? (
                        <ReservationCardList
                            reservations={allReservationList}
                            onRequestUpdate={(reservation) => this.pageState.attend(reservation)}
                        />
                    ) : (
                        <div styleName="no_reservation">
                            本日予約されているイベントは<br />ありません
                        </div>
                    )}
                </div>
            </Page>
        );
    }
}
